import { MapPin } from "lucide-react";
import Reveal from "@/components/Reveal";
import { scrollToSection } from "@/App";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#070B14] pt-20 pb-10">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal>
        <a
          href="#contact"
          onClick={scrollToSection("#contact")}
          data-testid="footer-lets-talk"
          className="block font-display text-[16vw] font-black leading-none tracking-tighter text-white transition-colors duration-500 hover:text-sky-400 md:text-[9rem]"
        >
          LET'S TALK<span className="text-sky-400">.</span>
        </a>
      </Reveal>

      <div className="mt-16 grid gap-10 border-t border-white/10 pt-10 md:grid-cols-3">
        <div>
          <p className="font-display text-lg font-black tracking-tight">
            FUTURE<span className="text-sky-400">/</span>
            <span className="ml-1 font-medium text-slate-400">SOLUTIONS</span>
          </p>
          <p className="mt-3 max-w-xs text-sm text-slate-500">
            Customer support, back-office and data operations for companies that refuse to slow down.
          </p>
        </div>
        <div className="text-sm">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Reach Us</p>
          <a href="tel:+917989534340" data-testid="footer-phone-link" className="block py-1 text-slate-300 transition-colors duration-300 hover:text-sky-400">
            +91 79895 34340
          </a>
          <a href="mailto:kkumar4601@gmail.com" data-testid="footer-email-link" className="block py-1 text-slate-300 transition-colors duration-300 hover:text-sky-400">
            kkumar4601@gmail.com
          </a>
          <p data-testid="footer-location" className="mt-2 flex items-center gap-2 py-1 text-slate-400">
            <MapPin className="h-4 w-4 text-sky-400" /> Kurnool, Andhra Pradesh, India
          </p>
        </div>
        <div className="text-sm">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Explore</p>
          {[
            ["Services", "#services", "footer-link-services"],
            ["Why Us", "#why-us", "footer-link-why-us"],
            ["Clients", "#testimonials", "footer-link-testimonials"],
            ["Contact", "#contact", "footer-link-contact"],
          ].map(([label, hash, testid]) => (
            <a
              key={hash}
              href={hash}
              onClick={scrollToSection(hash)}
              data-testid={testid}
              className="block py-1 text-slate-300 transition-colors duration-300 hover:text-sky-400"
            >
              {label}
            </a>
          ))}
        </div>
      </div>

      <div className="mt-14 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 text-xs text-slate-600 md:flex-row">
        <p>© {new Date().getFullYear()} Future Solutions. All rights reserved.</p>
        <p>We answer. We process. You scale.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
